<template v-once>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <span role="button" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="searchText = '';checkDelays()">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </span>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" placeholder="Wyszukaj w panelu" @input="checkDelays">
        </div>
      </div>
      <button
        class="bg-white border-0"
        :class="{ 'text-primary': !this.refreshing, 'text-secondary': this.refreshing }"
        @click="refreshReport"
        :disabled="refreshing"
      >
        <i class="fas fa-sync"></i>
        <span v-if="!refreshing">
          Odśwież
        </span>
        <span v-else>
          Wczytuję...
        </span>
      </button>
    </div>
    <hr>
    <div class="row">
      <div class="d-lg-flex justify-content-between my-2">
        <h5 class="fw-bold">
          RAPORTY I STATYSTYKI
        </h5>
      </div>
    </div>
    <h2>Raport spóźnień</h2>
    <div class="text-success fw-bold">
      Odświeżenie raportu za: {{ countDown }} s
    </div>
    <table class="table my-5">
      <thead>
      <tr class="fw-bold sticky-top bg-white" style="top: 57px;">
        <td>vrid</td>
        <td>Postój</td>
        <td>Nr rejestracyjny</td>
        <td
          role="button"
          @click="checkDelays()"
        >
          <i class="fas fa-sort"></i>
          Plan
        </td>
        <td>Szacowany czas przyjazdu wg Google</td>
        <td>Szacowany czas przyjazdu wg algorytmu</td>
        <td>Faktyczny przyjazd</td>
        <td>Informacje o obliczeniach</td>
        <td>Akcje</td>
      </tr>
      </thead>
      <tbody
        v-for="(delay, mainIndex) in $store.getters.getReports"
        :key="mainIndex"
      >
      <tr
        :class="delay.bg === 'white' ? `bg-white delay-row-${delay.taskId}` : `bg-grey delay-row-${delay.taskId}`"
        :style="delay.hasBorder ? 'border-bottom: 4px solid black;' : 'border-bottom: hidden;'"
        :key="`${mainIndex}-tr`"
      >
        <td>{{ delay.taskNumber }}</td>
        <td>{{ delay.acronym }}</td>
        <td>{{ delay.vehicle }}</td>
        <td>{{ delay.plannedArrival?.replace('T', ' ').split('.')[0] }}</td>
        <td>{{ delay.estimatedArrivalGoogle?.replace('T', ' ').split('.')[0] }}</td>
        <td
          :class="delay.delayed ? 'text-danger fw-bold' : 'text-success fw-bold'"
        >
          {{ delay.estimatedArrivalAlgorithm?.replace('T', ' ').split('.')[0] }}
        </td>
        <td>{{ delay.actualArrival?.replace('T', ' ').split('.')[0] }}</td>
        <td>{{ delay.message }}</td>
        <td>
          <button
            @click="ignoreDelay(delay.taskId)"
            class="btn btn-warning">
            Ukryj
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Report',
  components: { Navbar },
  data () {
    return {
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      isAscOrdering: null,
      searchText: '',
      isSearchVisible: false,
      intervalID: null,
      refreshing: false,
      ignoredDelays: [],
      countDown: 300,
      controller: new AbortController()
    }
  },
  created () {
    this.$store.commit('setInitialCalendarLoading', true)

    emitter.on(eventKinds.calendarShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.storehouseShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.driverListingShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.placesShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.tasksListShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.usersShown, () => {
      this.controller.abort()
    })

    if (this.countDown > 0) {
      this.intervalID = setInterval(() => {
        this.countDown--

        if (this.countDown === 0) {
          this.countDown = 300
          this.refreshReport()
        }

      }, 1000)
    }
  },
  mounted () {
    this.checkDelays()
  },
  watch: {
    $route (to, from) {
      window.clearInterval(this.intervalID)
    }
  },
  methods: {
    async refreshReport () {
      this.refreshing = true

      this.$store.commit('setReports', [])
      this.countDown = 300

      const delays = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Delay`, this.axiosConfig)).data
      let storableDelays = []

      delays.map((delay, mainIndex) => {
        delay.stoppageDelays.map((stoppageDelay, index) => {
          stoppageDelay.taskId = delay.taskId
          stoppageDelay.taskNumber = delay.taskNumber
          stoppageDelay.bg = mainIndex % 2 === 0 ? 'white' : 'light'
          stoppageDelay.hasBorder = delay.stoppageDelays.length === index + 1
          stoppageDelay.hasHideButton = index === 0
          stoppageDelay.route = delay.route
          stoppageDelay.vehicle = delay.vehicle
          stoppageDelay.acronym = delay.route.split('->')[index]

          if (!stoppageDelay?.acronym?.match(/^P\d$/)) {
            storableDelays.push(stoppageDelay)
          }
        })
      })

      if (this.isAscOrdering) {
        storableDelays = storableDelays.sort((a, b) => {
          const aDate = new Date(a?.plannedArrival)
          const bDate = new Date(b?.plannedArrival)
          return aDate - bDate
        })
      } else {
        storableDelays = storableDelays.sort((a, b) => {
          const aDate = new Date(a?.plannedArrival)
          const bDate = new Date(b?.plannedArrival)
          return bDate - aDate
        })
      }

      storableDelays = storableDelays.filter(sD => !sD.actualArrival || ((new Date(sD.actualArrival).getTime() + (1000 * 60 * 60)) > Date.now()))
      storableDelays = storableDelays.filter(sD => new Date(sD.plannedArrival).getTime() > new Date().getTime())

      this.$store.commit('setReports', storableDelays)
      await this.setChangesVehicles()

      this.refreshing = false
    },

    async checkDelays () {
      if (!this.isAscOrdering) {
        this.isAscOrdering = true
      } else {
        this.isAscOrdering = !this.isAscOrdering
      }

      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }, signal: this.controller.signal }

      let delays = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Delay`, config)).data
      let storableDelays = []

      delays.map((delay, mainIndex) => {
        delay.stoppageDelays.map((stoppageDelay, index) => {
          stoppageDelay.taskId = delay.taskId
          stoppageDelay.taskNumber = delay.taskNumber
          stoppageDelay.bg = mainIndex % 2 === 0 ? 'white' : 'light'
          stoppageDelay.hasBorder = delay.stoppageDelays.length === index + 1
          stoppageDelay.hasHideButton = index === 0
          stoppageDelay.route = delay.route
          stoppageDelay.vehicle = delay.vehicle
          stoppageDelay.acronym = delay.route.split('->')[index]

          if (!stoppageDelay?.acronym?.match(/^P\d-\d/) && !stoppageDelay?.acronym?.match(/^P\d$/) && !stoppageDelay?.acronym?.includes('trailerChange')) {
            storableDelays.push(stoppageDelay)
          }
        })
      })

      if (this.searchText !== '') {
        storableDelays = storableDelays.filter(
          storableDelay => storableDelay.taskNumber.toLowerCase().includes(this.searchText.toLowerCase()) ||
            storableDelay.vehicle.toLowerCase().includes(this.searchText.toLowerCase()) ||
            storableDelay?.acronym?.toLowerCase().includes(this.searchText.toLowerCase())
        )
      }

      if (this.isAscOrdering) {
        storableDelays = storableDelays.sort((a, b) => {
          const aDate = new Date(a?.plannedArrival)
          const bDate = new Date(b?.plannedArrival)
          return aDate - bDate
        })
      } else {
        storableDelays = storableDelays.sort((a, b) => {
          const aDate = new Date(a?.plannedArrival)
          const bDate = new Date(b?.plannedArrival)
          return bDate - aDate
        })
      }

      storableDelays = storableDelays.filter(sD => !sD.actualArrival || ((new Date(sD.actualArrival).getTime() + (1000 * 60 * 60)) > Date.now()))
      storableDelays = storableDelays.filter(sD => new Date(sD.plannedArrival).getTime() > new Date().getTime())

      this.$store.commit('setReports', storableDelays)
      await this.setChangesVehicles()
    },

    async ignoreDelay (taskId) {
      const postData = { id: taskId }
      const ignoredDelayRows = [...document.querySelectorAll(`.delay-row-${taskId}`)]

      ignoredDelayRows.forEach(r => r.classList.add('d-none'))

      this.refreshing = true
      await axios.post(`${process.env.VUE_APP_API_BASE_URL}${taskId}/IgnoreInDelayReport`, postData, this.axiosConfig)
      await this.$store.commit('setReports', this.$store.getters.getReports.filter(delay => delay.taskId !== taskId))
      this.refreshing = false
    },

    async setChangesVehicles () {
      const delays = this.$store.getters.getReports

      delays.map(async delay => {
        const task = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/${delay.taskId}`, this.axiosConfig)).data
        const taskStoppages = task.stoppages
        const taskChanges = task.changes

        let changeStoppageIndex = 0

        if (taskChanges.length > 0) {
          taskStoppages.map((taskStoppage, index) => {
            if (taskStoppage?.acronym?.match(/^P\d-\d/) && !taskStoppage?.acronym?.match(/^P\d$/) && taskStoppage?.acronym?.includes('trailerChange')) {
              changeStoppageIndex = index
            }
          })

          taskStoppages.slice(0, changeStoppageIndex).map(beforeChangeStoppage => {
            if (beforeChangeStoppage.acronym === delay.acronym) {
              delay.vehicle = task.auto.name
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.bg-grey {
  background-color: #bfbfbf;
}
</style>
